import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const autoCompleteApi = createApi({
  reducerPath: "autoCompleteApi", // path to the reducer
  baseQuery: fetchBaseQuery({
    baseUrl: "https://maps.googleapis.com/maps/api/place/autocomplete",
    headers: (headers, { getState }) => {
      headers.set("content-type", "application/json");
      headers.set("Access-Control-Allow-Origin", null);
      return headers;
    },
    mode: "cors",
  }), // base query to fetch data
  endpoints: (builder) => ({
    getPredictions: builder.query({
      query: ({ input }) =>
        `json?input=${input}&location=30.76999%2C30.44696&key=${process.env.REACT_APP_MAPS}&radius=500000&languag=ar`,
    }),
  }),
});

export const { useLazyGetPredictionsQuery } = autoCompleteApi;
